import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { pathnameSelector } from '../features/routerSlice';
import { bootstrapInitialize } from '../features/bootstrapSlice';
import { Routes } from './agora/Routes';
import { GlobalMessage } from '../components/GlobalMessage';
import { isAppReadySelector } from '../features/bootstrapSlice';
import {
  currentUserDisplayNameSelector,
  currentUserIdSelector,
  doLoginInitialize,
  doLogoutInitialize,
  isAuthorizedSelector,
  isAuthorizingSelector,
} from '../features/authenticationSlice';
import { versionSelector } from '../features/apiFeatures/versionSlice';

const Agora = () => {
  const dispatch = useDispatch();
  const isAppReady = useSelector(isAppReadySelector);
  const userId = useSelector(currentUserIdSelector);
  const displayName = useSelector(currentUserDisplayNameSelector);
  const isLoggedIn = useSelector(isAuthorizedSelector);
  const isAuthorizing = useSelector(isAuthorizingSelector);
  const pathname = useSelector(pathnameSelector);
  const be_version = useSelector(versionSelector);

  const onLoginClick = () => {
    dispatch(doLoginInitialize());
  };

  const onLogoutClick = () => {
    dispatch(doLogoutInitialize());
  };

  useEffect(() => {
    if (!isAppReady) {
      dispatch(bootstrapInitialize());
    }
  }, [dispatch, isAppReady]);

  useEffect(() => {
    const getVersion = () => {
      return {
        fe: process.env.REACT_APP_BUILD_VERSION || null,
        be: be_version || null,
      };
    };
    window.HP_VERSION = getVersion();
  }, [be_version]);

  return (
    <div>
      <Routes
        pathname={pathname}
        userId={userId}
        displayName={displayName}
        isLoggedIn={isLoggedIn}
        isAuthorizing={isAuthorizing}
        onLoginClick={onLoginClick}
        onLogoutClick={onLogoutClick}
      />
      <GlobalMessage />
    </div>
  );
};

export { Agora };
